<template>
  <div class="layer4" v-if="list.upModels">
    <div class="header-title">
      <img src="../../images/sprite-left.png" alt="">
      <span>{{list.floorName}}</span>
      <img src="../../images/sprite-right.png" alt="">
    </div>
    <ul class="ul-cls goodList" v-if="list.upModels">
      <li v-for="item in list.upModels[0].goodsInfo" :key="item.goodsId">
      <!--eslint-disable-next-line-->
      <a :href="item.linkUrl" target="_blank">
          <div class="goodImg">
            <img :src="`${item.imgUrl}?imageView2/1/w/320/h/200`" alt="" v-if="item.imgUrl">
            <img src="./storebg.png" alt="" v-else>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
export default {
  name: 'Layer4',
  props: {
    type4: Object,
  },
  data() {
    return {
      origin: process.env,
      list: this.type4,
    };
  },
  watch: {
    type4(newVal) {
      this.list = newVal;
    },
  },
};
</script>
